import { Box, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function TalentDiscovery() {
  const { t } = useTranslation("heropage");

  const categories = t("talent.categories", { returnObjects: true });

  return (
    <Box
      sx={{
        px: { xs: 3, md: 12 },
        py: { xs: 14, md: 22 },
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* Editorial Intro */}
      <Box sx={{ maxWidth: 900, mb: 16 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "2.6rem", md: "3.8rem" },
            lineHeight: 1.15,
            mb: 5,
          }}
        >
          {t("talent.intro.title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "1.1rem",
            lineHeight: 2,
            color: "#444",
          }}
        >
          {t("talent.intro.description")}
        </Typography>
      </Box>

      {/* Philosophy Block */}
      <Grid container spacing={10} sx={{ mb: 18 }}>
        <Grid item xs={12} md={6}>
          <Typography
            sx={{
              fontFamily: "Playfair Display",
              fontSize: "1.9rem",
              mb: 4,
            }}
          >
            {t("talent.philosophy.title")}
          </Typography>

          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "1rem",
              lineHeight: 2,
              color: "#555",
            }}
          >
            {t("talent.philosophy.left")}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "1rem",
              lineHeight: 2,
              color: "#555",
            }}
          >
            {t("talent.philosophy.right")}
          </Typography>
        </Grid>
      </Grid>

      {/* Categories */}
      <Grid container spacing={8}>
        {categories.map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.08 }}
            >
              <Box
                sx={{
                  p: { xs: 4, md: 6 },
                  borderRadius: "20px",
                  backgroundColor: "#F6F5F3",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.06)",
                  height: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Playfair Display",
                    fontSize: "1.6rem",
                    mb: 3,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "0.98rem",
                    lineHeight: 1.9,
                    color: "#555",
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* Closing Invitation */}
      <Box sx={{ maxWidth: 760, mt: 18 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: "1.9rem",
            lineHeight: 1.4,
          }}
        >
          {t("talent.closing")}
        </Typography>
      </Box>
    </Box>
  );
}
